/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CompleteAccountEmailInput = {
    readonly email: string;
    readonly clientMutationId?: string | null;
};
export type completeAccountEmailMutationVariables = {
    readonly input: CompleteAccountEmailInput;
};
export type completeAccountEmailMutationResponse = {
    readonly completeAccountEmail: {
        readonly message: string | null;
    } | null;
};
export type completeAccountEmailMutation = {
    readonly response: completeAccountEmailMutationResponse;
    readonly variables: completeAccountEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CompleteAccountEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "completeAccountEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CompleteAccountEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "message",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "completeAccountEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "completeAccountEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "completeAccountEmailMutation",
            "id": "ferrum/234.0.0-2019-09-26T17:57:22.088Z/completeAccountEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '883b4525d2b17ac04896e764ae2e1f1b';
export default node;
